module.exports = __webpack_public_path__ + "static/media/thumbnail.b43f434e.webp";